var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.language["common.importExcel"],
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        confirmLoading: _vm.uploading
      },
      on: { cancel: _vm.handleClose }
    },
    [
      _vm.online
        ? _c("div", { staticStyle: { margin: "0px 0px 5px 1px" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  display: "inline-block",
                  height: "32px",
                  "line-height": "32px",
                  "vertical-align": "middle"
                }
              },
              [
                _vm._v(_vm._s(_vm.language["common.openValidOrNot"])),
                _vm._v(":")
              ]
            ),
            _c(
              "span",
              {
                staticStyle: {
                  display: "inline-block",
                  height: "32px",
                  "margin-left": "6px"
                }
              },
              [
                _c("a-switch", {
                  attrs: {
                    checked: _vm.validateStatus == 1,
                    "checked-children": "是",
                    "un-checked-children": "否",
                    size: "small"
                  },
                  on: { change: _vm.handleChangeValidateStatus }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "div",
        [
          _vm._v(
            '通过此功能导入Excel文件，您可以实现活動與場館"' +
              _vm._s(_vm.operation.titleSetSeat) +
              '"的人員信息的批量選座操作；请您在导入之前，下载最新的Excel模板'
          ),
          _c(
            "a-button",
            {
              staticStyle: { left: "20px" },
              attrs: { type: "primary", icon: "download" },
              on: { click: _vm.ExportTemplateXls }
            },
            [_vm._v(_vm._s(_vm.language["system.downloadTemplate"]))]
          )
        ],
        1
      ),
      _c(
        "a-upload",
        {
          attrs: {
            name: "file",
            accept: ".xls,.xlsx",
            multiple: false,
            fileList: _vm.fileList,
            remove: _vm.handleRemove,
            beforeUpload: _vm.beforeUpload
          }
        },
        [
          _c(
            "a-button",
            [
              _c("a-icon", { attrs: { type: "upload" } }),
              _vm._v(
                "\n        " + _vm._s(_vm.language["common.chooseImportFile"])
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowErrorData,
              expression: "isShowErrorData"
            }
          ]
        },
        [
          _c(
            "div",
            [
              _vm._v(_vm._s(_vm.errorMsg) + " "),
              _c(
                "a-button",
                {
                  staticStyle: { left: "20px" },
                  attrs: { type: "primary", icon: "download" },
                  on: { click: _vm.handleExportErrData }
                },
                [_vm._v("导出错误数据")]
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c("a-table", {
                staticClass: "j-table-force-nowrap",
                attrs: {
                  dataSource: _vm.dataSource,
                  columns: _vm.columns,
                  size: "middle",
                  bordered: "",
                  rowKey: "sysid",
                  scroll: { x: 1800 }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.language["common.closeButton"]))
          ]),
          _c(
            "a-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.fileList.length != 1,
                loading: _vm.uploading
              },
              on: { click: _vm.handleImport }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.uploading
                      ? _vm.language["common.uploading"] + "..."
                      : _vm.language["common.startUpload"]
                  )
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }